import axios from "axios";
import { supabase } from "../supabaseClient";

// CRM 2.0 project switch (M1-F5). The server checks the permission
// Project › View Project Details › Settings › CRM 2.0 Switch and runs the health check
// before a switch-on.
const base = (projectId) => `${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/projects/${projectId}/switch`;
const auth = () => ({ headers: { Authorization: `Bearer ${supabase.auth.session()?.access_token}` } });

// Returns { isCrm2, crm2SwitchedAt }
async function getProjectSwitch(projectId) {
  return (await axios.get(base(projectId), auth())).data;
}

// on: true / false. A refused switch-on answers 409 with { message, health }.
async function setProjectSwitch(projectId, on) {
  return (await axios.post(base(projectId), { on }, auth())).data;
}

export { getProjectSwitch, setProjectSwitch };
